import { z } from 'zod';

export const getPractitionerDetailsSchema = z.object({
  practitioner_id: z.string().min(1, 'Practitioner ID is required'),
});

export type GetPractitionerDetailsPayload = z.infer<typeof getPractitionerDetailsSchema>;
